import React, { Fragment } from 'react';
import { IUpsellRule } from '../../interfaces';
import MilestoneCircle from './milestone-circle';
import { UpsellType2ProgressBarMilestones } from './UpsellType2ProgressBarMilestones';

interface IProgressBarType2Props {
    upsellRules: IUpsellRule[];
    userValue: number;
}

const MILESTONE_HEIGHT = '7px';

const ProgressBarType2 = ({ upsellRules, userValue }: IProgressBarType2Props) => {

    const data = new UpsellType2ProgressBarMilestones(
        upsellRules,
        userValue
    );

    return (
        <div
            role="progressbar"
            aria-labelledby="free-plugin-progress-label"
            className="w-full bg-green-100"
            style={{
                marginBottom: '45px'
            }}
        >
            <div className="flex items-center w-full relative" style={{
                justifyContent: 'space-evenly',
                gap: '3px',
            }}>
                {
                    data.milestones.map((milestone, index) => {

                        return (
                            <Fragment key={ milestone.id }>
                                <div
                                    className="flex-1"
                                    style={{
                                        backgroundColor: milestone.isPassed ? '#00BA90' : 'rgb(207, 207, 207)',
                                        height: MILESTONE_HEIGHT,
                                        borderRadius: milestone.borderRadius,
                                    }}
                                />

                                {
                                    data.shouldShowCircle(index) &&
                                    <MilestoneCircle
                                        isChecked={  milestone.isPassed }
                                        pluginsCount={ index + 1 }
                                        upsellRule={ data.getUpsellRule(index + 1) }
                                        isLast={ milestone.isLast }
                                    />
                                }
                            </Fragment>
                        )
                    })
                }
            </div>
        </div>
    )
};



export default ProgressBarType2;